import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BASE_URL } from "../../components/BASE_URL";

const Terms = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const [loading, setLoading] = useState(true);
  const [htmlContent, setHtmlContent] = useState("");

  // ----------------------------------
  // Fetch Terms (EN + ES handling)
  // ----------------------------------
  useEffect(() => {
    async function fetchTerms() {
      try {
        const res = await fetch(`${BASE_URL}/terms`, { method: "GET" });
        const json = await res.json();

        console.log("GET WEBSITE TERMS:", json);

        const currentLang = localStorage.getItem("i18nextLng") || "en";
        console.log("CURRENT TERMS LANG:", currentLang);

        if (!json.error && json.data) {
          const selected =
            currentLang === "es"
              ? json.data.content_es || json.data.content
              : json.data.content;

          console.log("SELECTED TERMS HTML:", selected?.slice(0, 100));

          setHtmlContent(selected);
        }
      } catch (error) {
        console.log("WEBSITE TERMS GET ERROR:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchTerms();
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F3F9FF", mt: isMobile ? 11 : 9 }}>
      <Box sx={{ backgroundColor: "white", py: isMobile ? 6 : 8 }}>
        <Box sx={{ px: isMobile ? 2 : 4 }}>
          {/* LOADER */}
          {loading ? (
            <Box
              sx={{
                minHeight: "40vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            // Render HTML (EN or ES)
            <div
              style={{
                fontFamily: "SF Pro Display, sans-serif",
                color: "#072533",
                fontSize: "16px",
                lineHeight: "1.8",
              }}
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Terms;





